import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Button, Card, Typography, Alert } from "antd";

const { Title, Text } = Typography;

export default function AdminLogin() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (values) => {
    setLoading(true);
    try {
      const response = await fetch("/api/auth/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });

      const data = await response.json();
      if (!response.ok) {
        setError(data.error || "Login failed");
        setLoading(false);
        return;
      }

      localStorage.setItem("jwt", data.token);
      setError("");
      navigate("/dashboard");
    } catch (e) {
      setError("Network error");
    }
    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundImage:
          "url('https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1600&q=80')", // tourist beach background
        backgroundSize: "cover",
        backgroundPosition: "center",
        position: "relative",
      }}
    >
      {/* Dark overlay for contrast */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.4)",
        }}
      />

      <Card
        style={{
          width: 400,
          borderRadius: 16,
          textAlign: "center",
          zIndex: 1,
          background: "rgba(255, 255, 255, 0.2)", // semi-transparent
          backdropFilter: "blur(10px)", // frosted glass effect
          WebkitBackdropFilter: "blur(10px)", // Safari support
          boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
          border: "1px solid rgba(255,255,255,0.3)",
        }}
        bordered={false}
      >
        <Title level={3} style={{ marginBottom: 8, color: "#fff" }}>
          Welcome To MHD
        </Title>
        <Text style={{ marginBottom: 24, display: "block", color: "#f0f0f0" }}>
          Please enter your login and password
        </Text>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            style={{ marginBottom: 16 }}
          />
        )}

        <Form layout="vertical" onFinish={handleLogin}>
          <Form.Item
            name="username"
            label={<span style={{ color: "#fff" }}>Username or E-mail</span>}
            rules={[{ required: true, message: "Please enter your username" }]}
          >
            <Input placeholder="Username" />
          </Form.Item>

          <Form.Item
            name="password"
            label={<span style={{ color: "#fff" }}>Password</span>}
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <Input.Password placeholder="Password" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              block
              loading={loading}
              style={{
                marginTop: 8,
                backgroundColor: "#28a745",
                borderColor: "#28a745",
              }}
            >
              Login
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
}
